export default __webpack_public_path__ + "static/media/pageNotFound.fe17e127.JPG";